import { Component } from '@angular/core';
import { FirstVisitCase } from '@ktypes/enums';

@Component({
  selector: 'kp-screen-full-privacy',
  templateUrl: './screen-full-privacy.component.html',
})
export class ScreenFullPrivacyComponent {
  fromScreen = FirstVisitCase.onboarding;
}
